import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@services/api';

// Fetch project metrics
export function useProjectMetrics(projectId, options = {}) {
  return useQuery({
    queryKey: ['metrics', 'project', projectId],
    queryFn: async () => {
      const response = await apiGet(`/metrics/project/${projectId}`);
      return response.data;
    },
    enabled: !!projectId,
    ...options,
  });
}

// Fetch burndown data for a sprint
export function useBurndownData(sprintId, options = {}) {
  return useQuery({
    queryKey: ['metrics', 'burndown', sprintId],
    queryFn: async () => {
      const response = await apiGet(`/metrics/burndown/${sprintId}`);
      return response.data;
    },
    enabled: !!sprintId,
    ...options,
  });
}

// Fetch velocity data
export function useVelocityData(projectId, limit = 10, options = {}) {
  return useQuery({
    queryKey: ['metrics', 'velocity', projectId, limit],
    queryFn: async () => {
      const response = await apiGet(`/metrics/velocity/${projectId}?limit=${limit}`);
      return response.data;
    },
    enabled: !!projectId,
    ...options,
  });
}

// Fetch team workload
export function useTeamWorkload(projectId, options = {}) {
  return useQuery({
    queryKey: ['metrics', 'workload', projectId],
    queryFn: async () => {
      const response = await apiGet(`/metrics/workload/${projectId}`);
      return response.data;
    },
    enabled: !!projectId,
    ...options,
  });
}
